module.exports = __webpack_public_path__ + "693cea2b1a3bf79cdeda4487f3fd204d.svg";